export const CONFIG = {
    // API_ENDPOINT :"https://portal.thediscipl.com/api/v1/" ,
    // BASE_URL :"https://portal.thediscipl.com/",
    API_ENDPOINT:"https://blacksquad.dev.fegno.com/api/v1/",
    BASE_URL :"https://blacksquad.dev.fegno.com/",
} 
